import { render, staticRenderFns } from "./EditInputField.vue?vue&type=template&id=83a8748c&scoped=true"
import script from "./EditInputField.vue?vue&type=script&setup=true&lang=js"
export * from "./EditInputField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditInputField.vue?vue&type=style&index=0&id=83a8748c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a8748c",
  null
  
)

export default component.exports